<template>
  <card header-classes="bg-transparent" v-loading="loading">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Pré-postagem</h6>
        <h5 class="h3 mb-0">Total</h5>
      </div>
      <div class="col">
        <el-select
          v-model="month"
          placeholder="Selecione uma opção"
          @change="change()"
        >
          <el-option key="day" label="Diário" value="day"></el-option>
          <el-option key="week" label="Semanal" value="week"></el-option>
          <el-option key="month" label="Mensal" value="month"></el-option>
        </el-select>
      </div>
    </div>
    <line-chart
      :height="250"
      ref="bigChart"
      :chart-data="bigLineChart.chartData"
      :extra-options="bigLineChart.extraOptions"
    ></line-chart>
  </card>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import { PrepostCountService } from "@/services/customers/prepost.count.services";

export default {
  name: "PrePostTotalByMonth",
  data() {
    return {
      month: "day",
      loading: false,
      chartData: null,
      bigLineChart: {
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    LineChart,
  },
  methods: {
    initBigChart(index) {
      const vm = this;
      vm.loading = true;
      PrepostCountService.month()
        .then((response) => {
          vm.chartData = response;
          const chartData = {
            datasets: [
              {
                label: "Quantidade",
                data: response[vm.month].values,
              },
            ],
            labels: response[vm.month].labels,
          };
          this.bigLineChart.chartData = chartData;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    change() {
      const vm = this;
      const chartData = {
        datasets: [
          {
            label: "Quantidade",
            data: vm.chartData[vm.month].values,
          },
        ],
        labels: vm.chartData[vm.month].labels,
      };
      this.bigLineChart.chartData = chartData;
    },
  },
  mounted() {
    this.initBigChart(0);
  },
};
</script>
